<template>
  <div class="page-content">
    <div class="headings d-flex">
      <h2 class="title title-primary">
        {{ $t("lang.admin.printer_form.page_title") }}
      </h2>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <bx-box
            :title="totalPrinters + ' ' + $t('lang.admin.list_of_printers')"
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalPrinters"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/printer/${props.row.id}/upload`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.serial_number }}</router-link
                    >
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.mac_address
                  }}</bx-table-column>

                  <!-- <bx-table-column centered class="pt-5">{{
                    props.row.area
                  }}</bx-table-column> -->
                  <!-- NEED TO ADD LOCATION ID AND LOCATION DESCRIPTION HERE -->
                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/admin/areas/${props.row.area}/edit`"
                      class="bx-link bx-link-bold"
                      >{{ props.row.area }}</router-link
                    >
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.ip_address
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.service_port
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">
                    <router-link
                      :to="`/printer/${props.row.id}/edit`"
                      class="bx-link bx-link-bold"
                      >{{
                        $t("lang.admin.printer_form.label_edit")
                      }}</router-link
                    >
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                    <a
                      class="bx-link bx-link-bold"
                      @click="deletePrinter(props.row.id)"
                      >{{ $t("lang.admin.printer_form.label_delete") }}</a
                    >
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DevicesList",
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      totalPrinters: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      try {
        let printers = await this.$api.printer.list({
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });
        this.data = printers.results;
        this.totalPrinters = printers.count;
      } catch (error) {
        console.error(error);
      } finally {
        this.columns = [
          {
            field: "serial_number",
            label: this.$t("lang.admin.label_serial_number"),
            centered: true
          },
          {
            field: "mac_address",
            label: this.$t("lang.admin.label_mac_address"),
            centered: true
          },
          {
            field: "area",
            label: this.$t("lang.admin.area"),
            centered: true
          },
          {
            field: "ip_address",
            label: this.$t("lang.admin.ip_address"),
            centered: true
          },
          {
            field: "service_port",
            label: this.$t("lang.admin.service_port"),
            centered: true
          },
          {
            field: "",
            label: this.$t("lang.admin.label_action"),
            centered: true
          },
          {
            field: "",
            label: this.$t("lang.admin.printer_form.label_delete"),
            centered: true
          }
        ];
        this.shouldLoading = false;
      }
    },
    async deletePrinter(id) {
      try {
        this.shouldLoading = true;
        await this.$api.printer.deletePrinter(id);
      } catch (error) {
        console.error(error);
      } finally {
        this.getData();
      }
    }
  }
};
</script>
